import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {DateFormat} from './shared/pipe/dateFormat';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {DBConfig, NgxIndexedDBModule} from 'ngx-indexed-db';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import {InternalService} from './shared/services/internal.service';
import {ApiService} from './shared/services/api.service';
import {RouterModule} from '@angular/router';
import {AppRoutingModule} from './app-routing.module';
import {NavbarComponent} from './shared/navbar/navbar.component';
import {FormComponent} from './pages/form/form.component';
import {FormsModule} from '@angular/forms';
import {NestedSelectComponent} from './shared/nested-select/nested-select.component';
import {MaterialModule} from './material-module';
import {NgxImageCompressService} from 'ngx-image-compress';
import {ImageCropperModule} from 'ngx-image-cropper';
import {HomeComponent} from './pages/home/home.component';
import {FooterComponent} from './shared/footer/footer.component';
import {ServicesComponent} from './pages/allServices/services.component';
import {ServiceDescriptionComponent} from './pages/serviceDescription/serviceDescription.component';
import {SliderComponent} from './shared/silder/silder.component';
import { TagSliderComponent } from './shared/tag-silder/tag-silder.component';
import {PageNotFoundComponent} from './pages/pageNotFound/pageNotFound.component';
import {TermsComponent} from './pages/terms/terms.component';
import {PrivacyComponent} from './pages/privacy/privacy.component';
import {ContactComponent} from './pages/contact/contact.component';
import {SearchComponent} from './shared/search/search.component';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { ProfileComponent } from './pages/profile/profile.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { DataSafetyPolicyComponent } from './pages/dataSafetyPolicy/dataSafetyPolicy.component';
 
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

const dbConfig: DBConfig  = {
  name: 'alobodoWebsite',
  version: 3,
  objectStoresMeta: [{
    store: 'Images',
    storeConfig: {keyPath: 'id', autoIncrement: true},
    storeSchema: [
      {name: 'MD5', keypath: 'MD5', options: {unique: true}},
      {name: 'icon', keypath: 'icon', options: {unique: true}}
    ]}
  ],
};

@NgModule({
  declarations: [
    AppComponent,
    DateFormat,
    NavbarComponent,
    FormComponent,
    NestedSelectComponent,
    HomeComponent,
    ServicesComponent,
    FooterComponent,
    SliderComponent,
    TagSliderComponent,
    ServiceDescriptionComponent,
    PageNotFoundComponent,
    TermsComponent,
    PrivacyComponent,
    DataSafetyPolicyComponent,
    ContactComponent,
    SearchComponent,
    ProfileComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule, // required animations module
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    // ServiceWorkerModule.register('ngsw-worker.js', {
    //   enabled: environment.production, scope: '/',
    //   registrationStrategy: 'registerImmediately'
    // }),
    NgxIndexedDBModule.forRoot(dbConfig),
    ToastrModule.forRoot(),
    RouterModule,
    FormsModule,
    MaterialModule,
    ImageCropperModule,
    IvyCarouselModule
  ],
  providers: [InternalService,ApiService,NgxImageCompressService],
  bootstrap: [AppComponent]
})
export class AppModule { }
